import { IntlShape } from 'react-intl';

const DRAFT_EXPIRY_DAYS = 60;
const MS_PER_DAY = 24 * 60 * 60 * 1000;

export const formatDate = (rawDate: string, intl: IntlShape) => {
  if (!rawDate) {
    return '';
  }
  const date = new Date(rawDate);
  if (isNaN(date.getTime())) {
    return rawDate;
  }
  const formattedDate = intl.formatDate(date, { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' });
  const formattedTime = intl.formatTime(date);
  return `${formattedDate} ${formattedTime}`;
};

export const getDraftExpiresInDays = (lockedDate?: string): number | undefined => {
  const locked = lockedDate ? new Date(lockedDate) : null;

  if (!locked || isNaN(locked.getTime())) {
    return undefined;
  }

  const expiryDate = locked.getTime() + DRAFT_EXPIRY_DAYS * MS_PER_DAY;
  const daysRemaining = Math.ceil((expiryDate - Date.now()) / MS_PER_DAY);

  return daysRemaining >= 0 ? daysRemaining : undefined;
};
